import Wt from "./filter-set.js";
export default class is {
  constructor(t, s) {
    (this.productId = t), (this.Jl = s), (this.productId = t), (this.Jl = s);
  }
  Bl(t) {
    if (null == this.productId || null == this.Jl) return !1;
    const s = t[0],
      i = t[1];
    return s === this.productId && this.Jl.Bl(i);
  }
  static fromJson(t) {
    return new is(
      t ? t.product_id : null,
      t ? Wt.fromJson(t.property_filters) : null,
    );
  }
  tt() {
    return { id: this.productId, pf: this.Jl ? this.Jl.tt() : null };
  }
}
